import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import GSTDataCollectionUI from './GSTDataCollectionUI.js'

const isLegacyFolder = (label) =>
  label && label.toLowerCase() === 'legacy files'

class GSTDataCollectionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // rec-collect GST report
      gstErrorList: null,
      gstSuccessMsg: null,
      gstSubmitted: false,
      // download files
      downloadRequested: false,
      fileErrorList: null,
      //
      skipCollectionModeGST: false,
      selectedSkipCollectionGST: null,
      gstSkippedSuccessMsg: null,
      gstSkippedErrorList: [],
      //
      gstReuploadErrorList: null,
      gstReuploadSuccessMsg: null,
      gstReuploadSubmitted: false,
      selectedReuploadFolder: null,
    }
  }

  render() {
    return (
      <GSTDataCollectionUI
        context={this.props.context}
        account={this.props.account}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        //
        gstErrorList={this.state.gstErrorList}
        gstSuccessMsg={this.state.gstSuccessMsg}
        gstSubmitted={this.state.gstSubmitted}
        onGSTSubmit={this.onGSTSubmit}
        gstFileList={this.props.gstFileList}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        //
        onSkipCollectionGST={this.onSkipCollectionGST}
        skipCollectionModeGST={this.state.skipCollectionModeGST}
        selectedSkipCollectionGST={this.state.selectedSkipCollectionGST}
        gstSkippedSuccessMsg={this.state.gstSkippedSuccessMsg}
        gstSkippedErrorList={this.state.gstSkippedErrorList}
        //
        gstReuploadErrorList={this.state.gstReuploadErrorList}
        gstReuploadSuccessMsg={this.state.gstReuploadSuccessMsg}
        gstReuploadSubmitted={this.state.gstReuploadSubmitted}
        selectedReuploadFolder={this.state.selectedReuploadFolder}
        onGSTReuploadClick={this.onGSTReuploadClick}
      />
    )
  }

  componentDidMount = () => {
    let context = this.props.context
  }

  onGSTSubmit = () => {
    let gstSubmitted = this.state.gstSubmitted
    if (gstSubmitted)
      return

    this.setState({
      gstSuccessMsg: null,
      gstErrorList: [],
      gstSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/gstReport/enableReCollection`,
      this.onGSTSubmitCallback, {}
    )
  }

  onGSTSubmitCallback = (response) => {
    let gstErrorList = []
(response.errorList || []).forEach(error => {
        gstErrorList.push(error.message)
    })

    this.setState({
      gstSuccessMsg: response.success,
      gstErrorList: gstErrorList,
      gstSubmitted: false
    })

   if ((response.errorList || []).length === 0) {
      setTimeout(() => {
        this.setState({ gstSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if ((response.errorList || []).length) {
      setTimeout(() => {
        this.setState({ gstErrorList: [] })
      }, 5000)
    }

  }

  onSkipCollectionGST = (event) => {
    console.log("skipcollectionGST")
    let gstNumber = event.currentTarget.getAttribute('data-row-id')
    this.setState({ selectedSkipCollectionGST: gstNumber, skipCollectionModeGST: true })
    console.log(gstNumber)
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/gstReport/${gstNumber}/skipCollection`, this.onSkipCollectionGSTCallback, null, null
    )
  }

  onSkipCollectionGSTCallback = (response) => {
    console.log("done")
    let errorList = []
(response.errorList || []).forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      gstSkippedSuccessMsg: response.success,
      gstSkippedErrorList: errorList,
      skipCollectionModeGST: false
    })

    if ((response.errorList || []).length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick()
      }, 3000)
    }
  }

  onDownloadFileClick = (event) => {
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let folder = event.currentTarget.getAttribute("data-folder")

    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl?folder=${folder}`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      window.open(response.signedUrl.signedUrl, '_blank')
    }
  }

  onGSTReuploadClick = (gstin, label) => {
    let gstReuploadSubmitted = this.state.gstReuploadSubmitted
    if (gstReuploadSubmitted)
      return

    const folder = isLegacyFolder(label) ? label : `${gstin}/${label}`

    this.setState({
      gstReuploadSuccessMsg: null,
      gstReuploadErrorList: [],
      gstReuploadSubmitted: true,
      selectedReuploadFolder: folder,
    })

    const folderParam = encodeURIComponent(folder)

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreMe/GST/scoreParameters?folder=${folderParam}`,
      this.onGSTReuploadClickCallback, {}
    )
  }

 onGSTReuploadClickCallback = (response) => {
    let gstReuploadErrorList = []
    
    if (!response || response.status === 500 || !response.errorList) {
      this.setState({
        gstReuploadSuccessMsg: null,
        gstReuploadErrorList: ['Server error occurred. Please try again.'],
        gstReuploadSubmitted: false
      })
      return
    }

    response.errorList.forEach(error => {
      gstReuploadErrorList.push(error.message || error)
    })

    this.setState({
      gstReuploadSuccessMsg: response.success,
      gstReuploadErrorList: gstReuploadErrorList,
      gstReuploadSubmitted: false,
    })

    if ((response.errorList || []).length === 0) {
      setTimeout(() => {
        this.setState({
          gstReuploadSuccessMsg: null,
          selectedReuploadFolder: null,
        })
        this.props.onRefreshClick()
      }, 3000)
    }

    if ((response.errorList || []).length) {
      setTimeout(() => {
        this.setState({
          gstReuploadErrorList: [],
          selectedReuploadFolder: null,
        })
      }, 5000)
    }
  }

}

export default GSTDataCollectionSF
